import { Reveal } from "@/components/Reveal";

export function SectionTitle({ kicker, title }) {
  return (
    <div className="text-center max-w-3xl mx-auto px-6">
      <Reveal>
        <p className="text-[11px] font-semibold tracking-[0.35em] uppercase text-[#4C8C1E]">{kicker}</p>
      </Reveal>
      <Reveal delay={0.1}>
        <h2 className="font-serif text-4xl md:text-5xl leading-[1.1] mt-4 text-[#16180F]">{title}</h2>
      </Reveal>
    </div>
  );
}

export default function Practice() {
  const go = (e, href) => {
    e.preventDefault();
    window.__lenis?.scrollTo(href, { offset: -70, duration: 1.2 });
  };

  return (
    <section id="about" data-testid="about-section" className="py-20 md:py-28">
      <div className="max-w-[1200px] mx-auto px-6">
        <Reveal>
          <p className="text-base md:text-lg font-light text-[#55564A] leading-[1.9] first-letter:font-serif first-letter:text-7xl first-letter:float-left first-letter:mr-4 first-letter:leading-[0.75] first-letter:text-[#16180F]">
            eProcure is a consulting practice focused on helping organizations improve
            business performance across strategy, transformation, finance, and advisory.
            We analyze organizational information to uncover actionable insights and turn
            them into strategies that transform businesses. From insight to execution, we
            work alongside you and stay engaged until the results show.
          </p>
          <p className="mt-8 text-base md:text-lg font-light text-[#55564A] leading-[1.9]">
            We are also building a web-based B2B marketplace that connects buyers and
            suppliers: buyers list their requirements and gain access to a curated database of
            suppliers ready to deliver. One marketplace, both sides of the table.
          </p>
          <div className="text-center mt-12">
            <a
              href="#contact"
              onClick={(e) => go(e, "#contact")}
              data-testid="hero-cta"
              className="inline-block text-[11px] font-semibold tracking-[0.3em] uppercase text-[#16180F] border-b-2 border-[#4C8C1E] pb-1 hover:text-[#4C8C1E] transition-colors duration-300"
            >
              Start a Conversation
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
